module.exports = __webpack_public_path__ + "img/c05_unitenneris_Normal_ua.3a2e35d5.webp";